// extracted by mini-css-extract-plugin
module.exports = {"root":"_2YyJk","header":"_3FLCC","title":"VSO4u","subtitle":"_3bx9n","cta":"_1dAAS","ctaTitle":"_2mLf9","ctaIcon":"_2ETHq","itemsWrapper":"_2fSmH"};